import { render, staticRenderFns } from "./ImagesSlide.vue?vue&type=template&id=05af876e&scoped=true"
import script from "./ImagesSlide.vue?vue&type=script&lang=js"
export * from "./ImagesSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05af876e",
  null
  
)

export default component.exports